import React from "react";

import { ControlReviewContext } from "../../components/ControlReviewProvider";

/**
 * Hook to access the ControlReviewContext value.
 *
 * @returns The ControlReviewContext value.
 * @throws Will throw an error if used outside of a ControlReviewContext provider.
 * @example
 * const controlReview = useControlReview();
 */
function useControlReview() {
  const controlReview = React.useContext(ControlReviewContext);

  if (controlReview === undefined) {
    throw new Error(
      "useControlReview must be used within a ControlReviewContext provider."
    );
  }

  return controlReview;
}

export default useControlReview;
